import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BizSkillsBadge from "../Assets/Biz Skills Badge.webp";
import TexasWorkforceCommissionLogo from "../Assets/twc-seal.webp";
import {
  AiFillYoutube,
  AiFillFacebook,  
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  const { t } = useTranslation();
  let date = new Date();
  let year = date.getFullYear();
  const exploreCards = [
    {
      title: `${t("nav.home")} & ${t("nav.about")}`,
      to: "/",
      links: [
        { label: t("nav.home"), to: "/" },
        { label: t("nav.whoWeAre"), to: "/about/who-we-are" },
        { label: t("nav.ourMission"), to: "/about/our-mission" },
        { label: t("nav.ourStory"), to: "/about/our-story" },
        { label: t("nav.ourPartners"), to: "/about/our-partners" },
      ],
    },
    {
      title: t("nav.programs"),
      to: "/courses",
      links: [
        { label: t("nav.careerTrainingPrograms"), to: "/courses" },
        { label: t("careerProgramsPage.hero.actions.admissions"), to: "/admissions" },
        { label: t("careerProgramsPage.hero.actions.catalog"), to: "/catalog" },
        { label: t("careerProgramsPage.hero.actions.studentResources"), to: "/student-resources" },
        { label: t("nav.workshopsExploratoryLearning"), to: "/programs/exploratory-learning" },
      ],
    },
    {
      title: t("nav.services"),
      to: "/services/consulting-advisory",
      links: [
        { label: t("nav.consultingAdvisory"), to: "/services/consulting-advisory" },
        { label: t("nav.projects"), to: "/projects" },
        { label: t("nav.cfLab"), to: "/lab" },
      ],
    },
    {
      title: t("nav.getInvolved"),
      to: "/impact/community",
      links: [
        { label: t("nav.internship"), to: "/programs/syep-internship" },
        { label: t("nav.grantsRecognition"), to: "/grants" },
        { label: t("nav.evidenceInAction"), to: "/programs/intern-experience" },
        { label: t("nav.communityPrograms"), to: "/programs/community-tech-programs" },
        { label: t("nav.ambassadors"), to: "/programs/ambassadors" },
        { label: t("nav.codeAndSoil"), to: "/programs/code-and-soil" },
        { label: t("nav.seniorTech"), to: "/programs/senior-citizens" },
        { label: t("nav.techPal"), to: "/programs/tech-pal" },
        { label: t("nav.partnerWithUs"), to: "/programs/partner-with-us" },
        { label: t("nav.volunteerOpportunities"), to: "/programs/volunteer-opportunities" },
      ],
    },
  ];
  const approvalText = t("footer.approvalStatement");
  const schoolNumberLabel = t("footer.schoolNumberLabel");
  const [approvalLead, approvalTail] = approvalText.split(schoolNumberLabel);
  return (
    <Container fluid className="footer">
      <Container className="footer-inner">
        <div className="footer-explore-section">
          <Row className="footer-explore-cards-row">
            {exploreCards.map((card) => (
              <Col md={4} className="footer-col footer-col--explore" key={card.title}>
                <h3 className="footer-heading footer-heading--card">
                  <Link className="footer-link footer-explore-parent" to={card.to}>
                    {card.title}
                  </Link>
                </h3>
                <ul className="footer-explore-sublinks" aria-label={`${card.title} links`}>
                  {card.links.map((subLink) => (
                    <li key={subLink.label}>
                      <Link className="footer-link footer-sublink" to={subLink.to}>
                        {subLink.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Col>
            ))}

            <Col md={4} className="footer-col footer-col--explore footer-col--contact">
              <h3 className="footer-heading footer-heading--card">{`${t("nav.team")} & ${t("nav.contact")}`}</h3>
              <div className="footer-item">
                <Link className="footer-link" to="/team">
                  {t("nav.team")}
                </Link>
              </div>
              <div className="footer-item">
                <Link className="footer-link" to="/contact">
                  {t("nav.contact")}
                </Link>
              </div>
              <div className="footer-item">
                <a className="footer-link" href="mailto:info@choicestfruit.com">
                  info@choicestfruit.com
                </a>
              </div>
              <div className="footer-item">{t("footer.location")}</div>
            </Col>

            <Col md={4} className="footer-col footer-col--explore footer-col--policies">
              <h3 className="footer-heading footer-heading--card">{t("footer.policies")}</h3>
              <ul className="footer-links" aria-label={t("footer.a11y.policies")}> 
                <li>
                  <Link className="footer-link" to="/policies/grievance-appeals">
                    {t("footer.grievanceAppeals")}
                  </Link>
                </li>
                <li>
                  <Link className="footer-link" to="/policies/privacy">
                    {t("footer.privacy")}
                  </Link>
                </li>
                <li>
                  <Link className="footer-link" to="/policies/terms">
                    {t("footer.terms")}
                  </Link>
                </li>
              </ul>
            </Col>
          </Row>
        </div>

        <div className="footer-approval" role="note" aria-label={t("footer.a11y.approvalStatement")}>
          {approvalLead}
          {approvalTail !== undefined ? (
            <>
              <span className="approval-school-number">{schoolNumberLabel}</span>
              {approvalTail}
            </>
          ) : null}
        </div>

        <div className="footer-procurement" role="note" aria-label={t("footer.a11y.procurement") }>
          <strong>{t("footer.procurement.title")}</strong>
          <span>{t("footer.procurement.details")}</span>
        </div>

        <Row className="footer-bottom">
          <Col md={4} className="footer-col footer-copyright">
            <div className="footer-item">{t("footer.copyright", { year })}</div>
          </Col>

          <Col md={4} className="footer-col footer-badge" aria-label={t("footer.a11y.badgeLabel")}>
            <div className="footer-badge-wrap">
              <img
                className="footer-badge-img footer-badge-img--twc"
                src={TexasWorkforceCommissionLogo}
                alt={t("footer.a11y.twcSeal")}
                loading="lazy"
              />
              <img
                className="footer-badge-img"
                src={BizSkillsBadge}
                alt={t("footer.a11y.badgeImage")}
                loading="lazy"
              />
              <div className="footer-badge-text">
                <div className="footer-badge-title">{t("footer.badge.title")}</div>
                <div className="footer-badge-subtitle">{t("footer.badge.subtitle")}</div>
              </div>
            </div>
          </Col>

          <Col md={4} className="footer-col footer-social">
            <ul className="footer-icons" aria-label={t("footer.a11y.socialLinks")}>
              <li className="social-icons">
                <a
                  href="https://www.youtube.com/@ChoicestFruit"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("footer.a11y.youtube")}
                >
                  <AiFillYoutube />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/profile.php?id=100083371838989"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("footer.a11y.facebook")}
                >
                  <AiFillFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/choicestfruit/"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("footer.a11y.instagram")}
                >
                  <AiFillInstagram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/company/choicest-fruit/"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("footer.a11y.linkedin")}
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Footer;
